import { render, staticRenderFns } from "./ModifierItemModal.vue?vue&type=template&id=daf9cce6"
import script from "./ModifierItemModal.vue?vue&type=script&lang=ts"
export * from "./ModifierItemModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports